import { Dropdown } from 'react-bootstrap'
import Flag from 'react-flagkit'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setLanguage } from '../actions/lang'
import Flags from '../Enum/Flags'
import Languages from '../Enum/Languages'
import { getPath } from '../MultilingualRouter/MultilingualRouter'

const LanguageDropdown = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const lang = useSelector((state) => state.lang.lang)
  const { pathName } = useSelector((state) => state.location)

  const changeLanguage = (language) => {
    dispatch(setLanguage(language))
    navigate(getPath(pathName, language))
  }

  return (
    <Dropdown className="my-3 my-xl-0 language-dropdown">
      <Dropdown.Toggle
        id="dropdown-language"
        className="w-100 d-flex align-items-center text-start text-xl-center px-2 text-muted border-0"
        variant="outline-light"
      >
        <Flag className="align-self-start" country={Flags[lang]?.code} />
        <span className="d-block d-xl-none ms-2">{Flags[lang]?.country}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        {Object.keys(Flags)?.map((language) => {
          if (JSON.stringify(Languages).includes(language)) {
            return (
              <Dropdown.Item
                key={language}
                onClick={() => changeLanguage(language)}
                disabled={lang === language}
                className={lang === language ? 'text-primary' : ''}
              >
                <Flag className="align-self-start me-2" country={Flags[language].code} />
                {Flags[language].country}
              </Dropdown.Item>
            )
          }
          return null
        })}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default LanguageDropdown
